import { useCallback, useEffect, useState } from 'react'

export type ToastKind = 'success' | 'error'
export interface ToastState {
  message: string
  kind: ToastKind
  id: number
}

export function useToast() {
  const [toast, setToast] = useState<ToastState | null>(null)

  useEffect(() => {
    if (!toast) return
    const t = window.setTimeout(() => setToast(null), 4000)
    return () => window.clearTimeout(t)
  }, [toast])

  const show = useCallback(
    (message: string, kind: ToastKind = 'success') =>
      setToast({ message, kind, id: Date.now() }),
    [],
  )

  return { toast, show }
}

export function Toast({ toast }: { toast: ToastState | null }) {
  const visible = !!toast
  return (
    <div
      className={[
        'fixed left-1/2 bottom-8 z-[999] -translate-x-1/2 rounded-[10px] px-6 py-3 text-sm font-medium transition-all duration-300',
        visible ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0',
        toast?.kind === 'error' ? 'bg-[#dc3545] text-white' : 'bg-[#3D3558] text-white',
      ].join(' ')}
      role="status"
      aria-live="polite"
    >
      {toast?.message ?? ''}
    </div>
  )
}
